<template>
  <div>
    <tip
      text="温馨提醒：91家纺网仓储商品免费保存6个月时间，超时仓储商品91家纺网将统一做公益处理。"
    />
    <div class="header_wrapper">
      <a-tabs type="card" v-model="currentTab" @change="changeTab">
        <a-tab-pane v-for="tab in tabList" :key="tab.path" :tab="tab.title">
        </a-tab-pane>
      </a-tabs>
    </div>
    <keep-alive>
      <router-view />
    </keep-alive>
  </div>
</template>

<script>
import Tip from "../../../tip";

export default {
  name: "Depot",
  components: { Tip },
  data() {
    return {
      tabList: [],
      houseList: [], //仓库
    };
  },
  computed: {},
  created() {
    this.tabList = this.getTabList();
  },
  methods: {
    getTabList() {
      var list = [
        {
          title: "现有仓储",
          path: "/depot/list",
        },
        {
          title: "历史仓储",
          path: "/depot/history",
        },
        {
          title: "仓储日志",
          path: "/depot/log",
        },
      ];
      return list;
    },
    changeTab(path) {
      this.$router.push({ path });
    },
  },
  watch: {
    $route: {
      handler(route) {
        this.currentTab = route.matched[0].path;
      },
      immediate: true,
    },
  },
};
</script>
<style scoped>
.header_wrapper {
  margin-top: 10px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding-right: 50px;
  border-bottom: 1px solid #e2e2e2;
  background: #fff;
}
.small_tip {
  font-size: 12px;
  color: #fd5902;
  padding-left: 20px;
  padding-bottom: 10px;
}
.header_wrapper >>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar {
  border-bottom: 0 !important;
}

>>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active {
  color: #fd5902 !important;
  background-color: unset !important;
  font-family: "PingFang SC";
  font-size: 14px;
  font-weight: 500;
  border-bottom: 2px solid #fd5902 !important;
  padding: 0;
}

>>> .ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab {
  border: unset;
  margin: 0 38px;
}

>>> .ant-tabs.ant-tabs-card
  .ant-tabs-card-bar
  .ant-tabs-nav-container
  .ant-tabs-tab {
  padding: 0;
}
</style>



// WEBPACK FOOTER //
// src/components/deal/depot/componets/DepotTips.vue